import {asset} from 'imba';
import url from './banner_scmp.jpeg';
export default asset({
	url: url,
	type: 'image',
	width: 1920,
	height: 1080,
	toString: function(){ return this.url;}
})